export default [
  {
    name: 'Red',
    value: '#FFCDD2'
  },
  {
    name: 'Pink',
    value: '#F8BBD0'
  },
  {
    name: 'Purple',
    value: '#E1BEE7'
  },
  // {
  //   name: 'Deep Purple',
  //   value: '#D1C4E9'
  // },
  // {
  //   name: 'Indigo',
  //   value: '#C5CAE9'
  // },
  {
    name: 'Blue',
    value: '#BBDEFB'
  },
  // {
  //   name: 'Light Blue',
  //   value: '#B3E5FC'
  // },
  // {
  //   name: 'Cyan',
  //   value: '#B2EBF2'
  // },
  // {
  //   name: 'Teal',
  //   value: '#B2DFDB'
  // },
  {
    name: 'Green',
    value: '#C8E6C9'
  },
  // {
  //   name: 'Light Green',
  //   value: '#DCEDC8'
  // },
  // {
  //   name: 'Lime',
  //   value: '#F0F4C3'
  // },
  {
    name: 'Yellow',
    value: '#FFF9C4'
  },
  // {
  //   name: 'Amber',
  //   value: '#FFECB3'
  // },
  {
    name: 'Orange',
    value: '#FFE0B2'
  },
  // {
  //   name: 'Deep Orange',
  //   value: '#FFCCBC'
  // },
  {
    name: 'Brown',
    value: '#D7CCC8'
  }
  // {
  //   name: 'Blue Gray',
  //   value: '#CFD8DC'
  // }
]
